import { Device } from "@capacitor/device";
import { Capacitor } from "@capacitor/core";
import { store } from "./storage";

const FALLBACK_KEY = "yelo.device.v1";

const randHex = (n: number) => {
  const a = new Uint8Array(n);
  crypto.getRandomValues(a);
  return Array.from(a, b => b.toString(16).padStart(2, "0")).join("");
};

// Returns a stable per-device identifier. iOS: IDFV; Android: ANDROID_ID; web: persisted UUID.
// IDFV resets only if all apps from this vendor are uninstalled — good enough for one-per-device.
export const getDeviceId = async (): Promise<string> => {
  try {
    const { identifier } = await Device.getId();
    if (identifier && identifier.length >= 4) return identifier;
  } catch {}
  // web fallback or rare native failure. The prefix encodes the platform: only a
  // genuine web client mints a "web-" id, which the server refuses at every
  // session-minting endpoint (the website is marketing-only). A rare native
  // getId() failure must NOT inherit the "web-" prefix or the native user would be
  // wrongly blocked — it gets an "ios-"/"android-" fallback instead.
  let id = await store.get<string>(FALLBACK_KEY);
  if (id) return id;
  const plat = Capacitor.getPlatform();
  const prefix = plat === "ios" || plat === "android" ? plat : "web";
  id = `${prefix}-${randHex(16)}`;
  await store.set(FALLBACK_KEY, id);
  return id;
};

export const getPlatform = (): "ios" | "android" | "web" => {
  const p = Capacitor.getPlatform();
  return (p === "ios" || p === "android") ? p : "web";
};
